export default __webpack_public_path__ + "static/media/stretch.a7a62171.png";